export default function dedupe(items) {
  return items.reduce((uniques, item) => (uniques.includes(item) ? uniques : uniques.concat(item)), []);
}
